import { fetchSharedGroup } from '@actions/shared/groups';
import { useAuthContext } from '@hooks/use-auth-context';
import Container from '@components/ContentContainer';
import { selectSharedGroup } from '@reducers/sharedData/groups';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createListContext, List as VirtualizedList } from '@components/List/VirtualizedList';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './SharedGroup.module.scss';
import { SharedContact } from '@models/SharedContact';
import ContactAvatar from '@components/ContactAvatar';
import SharedContactPreview from '@views/SharedWithMe/SharedContactPreview';
import SharedViewWrapper from '@components/Sharing/SharedViewWrapper';
import SharedGroupHeader from './SharedGroupHeader';

/*
TODO:
- Include scroll restoration
*/

const SharedGroupListContext = createListContext();

const renderSharedContactItem = (contact: SharedContact) => (
  <div className={styles.sharedContactRow}>
    {contact.displayName}
    <ContactAvatar size="sm" contact={contact} />
  </div>
);

// The "highlighted" shared contact can be tracked in component state for now. Once we have
// actions a user can take on shared contacts, we will want to move this into Redux (as well
// as selection state for the multiselect list)
export default function SharedGroup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { uuid: groupUUID } = useParams();
  const sharedGroup = useSelector(selectSharedGroup(groupUUID));
  const headerRef = useRef(null);
  const scrollingContainerRef = useRef(null);
  const [highlightedContact, setHighlightedContact] = useState(null);
  const [displayLogIn, setDisplayLogIn] = useState(false);

  useEffect(() => {
    if (groupUUID) {
      dispatch(fetchSharedGroup(groupUUID, user));
    }
  }, [groupUUID]);

  // useScrollingClass(containerRef, 'contact-scrolled');
  // useAutoFocus(containerRef);

  console.log('sharedGroup', sharedGroup);

  return (
    <SharedViewWrapper
      sharedResourceType="group"
      displayLogIn={displayLogIn}
      error={sharedGroup.error}
    >
      <Container key={groupUUID}>
        <Container.Primary
          className={styles.container}
          id="content"
          header={<SharedGroupHeader group={sharedGroup} logIn={() => setDisplayLogIn(true)} />}
        >
          <VirtualizedList
            shouldResetHighlight={false}
            canLoadMore={false}
            items={sharedGroup.contactsMap.valueSeq().toArray()}
            ListContext={SharedGroupListContext}
            headerCutoff={1}
            headerRef={headerRef}
            ref={scrollingContainerRef}
            defaultHighlightedIdx={0}
            onItemHighlight={(contact: SharedContact) => setHighlightedContact(contact)}
            onItemClick={(contact: SharedContact) => navigate(`/share/contact/${contact.id}`)}
            renderItem={renderSharedContactItem}
            contextMenuDisabled
          />
        </Container.Primary>
        <SharedContactPreview className={styles.sidebar} contactUUID={highlightedContact?.id} />
      </Container>
    </SharedViewWrapper>
  );
}
